/* eslint-disable unicorn/prefer-module */
import React, { useMemo } from "react";
import { useAuthContext } from "../../context/auth";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { fullScreenPlugin } from "@react-pdf-viewer/full-screen";
import { getFilePlugin } from "@react-pdf-viewer/get-file";
import "@react-pdf-viewer/full-screen/lib/styles/index.css";
import "./stylesMediakitEdificiosFullCbre.scss";

function MediakitEdificiosFullCbre() {
  const { pais } = useAuthContext();
  const newplugin = defaultLayoutPlugin();
  const getFilePluginInstance = getFilePlugin();
  const fullScreenPluginInstance = fullScreenPlugin();

  const mediakit = useMemo(
    () =>
      ({
        Chile: require("../../pdf/edificios-wecast-full-cbre.pdf"),
        Perú: require("../../pdf/edificios-wecast-full-cbre.pdf"),
        Uruguay: require("../../pdf/edificios-wecast-full-cbre.pdf"),
      })[pais] || require("../../pdf/edificios-wecast-full-cbre.pdf"),
    [pais]
  );

  return (
    <div className="pdf-container">
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
        <Viewer fileUrl={mediakit} plugins={[newplugin, getFilePluginInstance, fullScreenPluginInstance]} />;
      </Worker>
    </div>
  );
}

export default MediakitEdificiosFullCbre;
